<template>
  <div class="orders-sort-by-currency">
    <p class="orders-sort-by-currency__title">
      {{ $t('orders.currencies') }}
    </p>
    <AtSelect
        v-if="hasCurrencies"
        class="orders-sort-by-currency__select"
        :placeholder="select_currencies"
        clearable
        :value="selectedCurrencies[0]"
        @on-change="changeSelect"
    >
      <AtOption v-for="currency in sortCurrencies" :key="currency.currency" :value="currency.currency" :label="currency.currency">
        <CurrencyImg class="currencyImg" :currency="currency.currency"/>
        {{ currency.currency }}
      </AtOption>
    </AtSelect>
  </div>
</template>

<script>

import {mapState, mapGetters, mapActions} from 'vuex';

import AtSelect from 'at-ui/src/components/select';
import AtOption from 'at-ui/src/components/option';
import CurrencyImg from "../CurrencyImg";

export default {
    name: 'OrdersSortByCurrency',
    components: {
        CurrencyImg,
        AtSelect,
        AtOption,
    },
    data() {
        return {
            selectedCurrencies: [],
        };
    },
    computed: {
        ...mapState('app', [
            'currencies',
        ]),
        ...mapGetters('app', [
            'hasCurrencies',
        ]),
        select_currencies() {
            return this.$t('orders.select_currencies');
        },
        sortCurrencies() {
            return this.currencies.filter(el => el.isFiat === false);
        },
    },
    beforeMount() {
        this.setCurrenciesFromUrl();
    },
    methods: {
        ...mapActions('orders', [
            'fetchOrders',
        ]),
        setCurrenciesFromUrl() {
            const currenciesFromUrl = this.$route.query.currencies;

            if (!currenciesFromUrl) {
                return false;
            }

            this.selectedCurrencies = currenciesFromUrl.split(',');
        },
        changeSelect(values) {
            const {
                $route,
                $router,
                fetchOrders,
            } = this;
            const val = values ? [values] : [];
            fetchOrders({
                route: $route,
                router: $router,
                currencies: val,
                excludeParams: ['page'],
            });
        },
    },
};

</script>

<style lang="scss" scoped>

.orders-sort-by-currency {
  width: 100%;
  &__title {
    margin-bottom: 8px;
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
  }

  &__select ::v-deep .at-select__selection {
    min-height: 28px;
    border: 1px solid var(--border-color);
    background: var(--secondary-color);
    color: var(--primary-font-color);
  }

  &::v-deep .at-select__dropdown {
    border: 1px solid var(--border-color);
    background: var(--bg-select);
  }

  ::v-deep .at-select__option--selected {
    background: var(--hover-color-select);
  }

  ::v-deep .at-select__dropdown .at-select__option {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);

    &:hover {
      background: var(--hover-color-select);
    }
  }

  ::v-deep .at-select__placeholder {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
  }

  ::v-deep .at-select__selection {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
  }

}
.currencyImg {
  margin-right: 15px;
  width: 30px;
  height: 30px;
}
::v-deep .at-select__dropdown .at-select__option {
  font-family: var(--font-family);
  font-size: var(--font-size-text-main);
  line-height: var(--line-height);
  color: var(--primary-font-color);

  padding: 10px;
  display: flex;
  align-items: center;

  &:hover {
    background: var(--hover-color-select);
  }
}
</style>
